module.exports = __webpack_public_path__ + "static/media/ODS05.eb2a06fe.jpg";